import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Course } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Create new course
 */
const createCourse = (): Promise<Course> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }

    AxiosClient.post(URL, {}, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default createCourse
